import React from "react";

const FlattenAtMarketCloseDocs = (
    <p>This will flatten the existing trade plan at around 3:59 pm,
        before the market closes</p>);
export default FlattenAtMarketCloseDocs;